module.exports = __webpack_public_path__ + "static/img/about-2.6a33025.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img/about-2.svg
// module id = 1339
// module chunks = 4